<div  [ngStyle]="{'background-color':color?.PrimaryColor}" style="background-color:rgb(234,250,254);overflow-y: scroll ;max-height:100% ;" >
    <!--(scroll)="onScroll($event)"  -->
  <span #tops></span>
  
  <app-insurance   style="font-size: small; "   (myOutput)="searchFlight()" ></app-insurance>
  
  <div class=" col-lg-12  " style="max-width: 100%; margin-top: -80px;position: sticky;  width:100%;"  > 
  <div class=" col-md-12 " style="margin-top: 20px;padding:20px ;overflow:auto;">
   
  <!--###################################   table ##################################################
       ###################################   table ################################################## 
        ###################################   table ##################################################-->
  
 
        <!-- <table mat-table [dataSource]="insuranceDataList" class="mat-elevation-z8 ">

            <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
              <th mat-header-cell *matHeaderCellDef >
                <ng-container [ngSwitch]="columnHeaderMap[col] || col" >
                    <span *ngSwitchCase="'name'">Coverage Coverages Limit</span>
                    <span *ngSwitchCase="'coverageType'">Indemnity / Fixed Benefits</span>
                    <span *ngSwitchCase="'deductible'">Deductible</span>
                    <span *ngSwitchCase="'siOption'">SI Option</span>
                    <span *ngSwitchCase="'refNo'">Ref. No</span>

                    	
                    <span *ngSwitchDefault>{{ columnHeaderMap[col] || col }}</span>
                  </ng-container>
                
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="col.startsWith('planType'); else normalCell">
                <span [innerHTML]="getSumInsuredByPlanType(element, col)">  {{ getSumInsuredByPlanType(element, col) }}</span>
                </ng-container>
                <ng-template #normalCell>
                  {{ element[col] }}
                </ng-template>
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          
          </table> -->
          <div class="table-wrapper zoomI ">
            <table mat-table [dataSource]="insuranceDataList" class="mat-elevation-z8 full-width-table">
          
              <!-- Dynamic Column Definitions -->
              <ng-container *ngFor="let col of displayedColumns; let i = index" [matColumnDef]="col">
                
                <!-- Header Cell -->
                <th mat-header-cell *matHeaderCellDef 
                    [ngClass]="{
                      'sticky-col': stickyColumns.includes(i)
                    }">
                  <ng-container [ngSwitch]="columnHeaderMap[col] || col" >
                    <span *ngSwitchCase="'name'">Coverage Coverages Limit</span>
                    <span *ngSwitchCase="'coverageType'">Indemnity / Fixed Benefits</span>
                    <span *ngSwitchCase="'deductible'">Deductible</span>
                    <span *ngSwitchCase="'siOption'">SI Option</span>
                    <span *ngSwitchCase="'refNo'">Ref. No</span>
                    <span *ngSwitchDefault>{{ columnHeaderMap[col] || col }}</span>
                  </ng-container>
                </th>
          
                <!-- Body Cell -->
                <td mat-cell *matCellDef="let element"
                    [ngClass]="{
                      'sticky-col': stickyColumns.includes(i)
                    }">
                  <ng-container *ngIf="col.startsWith('planType'); else normalCell">
                    <span [innerHTML]="getSumInsuredByPlanType(element, col)">
                      {{ getSumInsuredByPlanType(element, col) }}
                    </span>
                  </ng-container>
                  <ng-template #normalCell>
                    {{ element[col] }}
                  </ng-template>
                </td>
          
                <!-- Footer Cell -->
                <td mat-footer-cell *matFooterCellDef sticky
                [ngClass]="{
                  'sticky-col': stickyColumns.includes(i)
                }">
                  <button *ngIf="!stickyColumn.includes(i)" (click)="generateBookingInsurance(columnHeaderMap[col])"
                          mat-flat-button
                          color="primary"
                         >
                    Book Now
                  </button>
                </td>
                
              </ng-container>
          
              <!-- Table Rows -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"  ></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns" ></tr>
            </table>
          </div>
          
          
          
  </div>
  <!--###################################  pendingFlight.gif ##################################################
       ################################### pendingFlight.gif  ################################################## 
        ################################### pendingFlight.gif ##################################################-->
        <div *ngIf="!showPending&&blankList" class=" no-result-container " style="padding: 1.3rem;text-align: center;background-color: antiquewhite;">
          <div class="icon">
            <!-- Use an SVG or FontAwesome icon for the magnifying glass -->
            <!-- <img src="assets/images/" alt="No Result Icon"> -->
          </div>
          <h2>No Result Found</h2>
          <p>Sorry, there are no matching results</p>
        </div>
        <div *ngIf="showPending" >
    <div class="gif-container">
      <!-- <img src="../../../../assets/images/insurancePending.gif" > -->
  </div>
  </div>
  
  
 
  
  
   
    